export function setDataInLocalStorage(key: any, value: any) {
  try {
    const valueToStore = JSON.stringify(value);
    if (typeof window !== "undefined") {
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    }
  } catch (error) {}
}

export function getDataFromLocalStorage(key: any) {
  if (typeof window === "undefined") return null;
  try {
    const item = window.localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    return null;
  }
}
